import { render, staticRenderFns } from "./LikeCounter.vue?vue&type=template&id=c49800a8&scoped=true&"
import script from "./LikeCounter.vue?vue&type=script&lang=js&"
export * from "./LikeCounter.vue?vue&type=script&lang=js&"
import style0 from "./LikeCounter.vue?vue&type=style&index=0&id=c49800a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49800a8",
  null
  
)

export default component.exports